/// <reference types="./events.d.mts" />
import * as $unsafe from "../../common_common/gleam/unsafe.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $attribute from "../../lustre/lustre/attribute.mjs";
import * as $event from "../../lustre/lustre/event.mjs";
import { Ok } from "../gleam.mjs";
import * as $file from "../web/browser/file.mjs";

export function return$(msg) {
  let _pipe = $event.on_click(msg);
  return $event.stop_propagation(_pipe);
}

export function stop_propagation() {
  let failing = $decode.failure($unsafe.coerce(""), "");
  let _pipe = $event.on("click", failing);
  return $event.stop_propagation(_pipe);
}

export function on_files_change(msg) {
  return $event.on(
    "change",
    $decode.then$(
      $decode.dynamic,
      (event) => {
        let $ = $file.from_event(event);
        if ($ instanceof Ok) {
          let files = $[0];
          return msg(files);
        } else {
          return $decode.failure($unsafe.coerce(""), "");
        }
      },
    ),
  );
}
